module.exports = __webpack_public_path__ + "assets/img/ffeb9d2a47530671d41209eb5a8fb808.png";